import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/activity";

export default createStore({ Model });
